<template lang="pug">
section.subpage.profile.pb-5(ref="subpage")
  h2.title
    span {{ page.title }}
  ValidationObserver(slim,ref="observer")
    b-form(ref="form",:data-mode="mode",@submit.prevent)
      //-b-button(@click="onChangePassword()",icon-fa="key",text="パスワード変更",:disabled="editable")
      b-container(fluid)
        b-row
          b-col(cols=6)
            b-form-group(label="社名",label-for="input-name",description="",required)
              ValidationProvider(rules="required",name="社名",v-slot="{ errors }")
                b-form-input#input-name(v-model="datum.name",type="text",required,placeholder="社名を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
          b-col(cols=6)
            b-form-group(label="社員数",label-for="input-headcount",description="",required)
              ValidationProvider(rules="required|min_value:1",name="社員数",v-slot="{ errors }")
                b-form-input#input-headcount(v-model="datum.headcount",type="number",required,placeholder="社員数を入力してください",min="1",@input="validateInput",:disabled="!editable",:readonly="!editable")
                .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
        b-row
          b-col(cols=6)
            b-form-group(label="設立年月日",label-for="input-foundationDate",description="")
              .form-inline.d-flex.align-items-start
                ValidationProvider(ref="foundationDate",rules="date",name="設立年月日",v-slot="{ errors }")
                  b-input-group
                    b-form-input#input-foundationDate(v-model="datum.foundationDate",type="date",placeholder="年/月/日",pattern="((19|20)\d\d)[\/\-]([1-9]|0[1-9]|1[012])[\/\-]([1-9]|0[1-9]|[12][0-9]|3[01])",required,@input="validateInput",:disabled="!editable",:readonly="!editable")
                    //-b-input-group-append
                      //b-form-datepicker(v-model="datum.foundationDate",button-only,locale="ja-JP",:date-format-options="{ year:'numeric', month: '2-digit', day: '2-digit', weekday: 'narrow' }",placeholder="設立年月日を設定してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                  .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
          b-col(cols=6)
            b-form-group(label="業界",label-for="input-segment",description="",required)
              ValidationProvider(rules="required",name="業界",v-slot="{ errors }")
                b-form-select#input-segment(v-model="datum.segment",:options="options.segments",placeholder="業界を選択してください",@change="validateInput",:disabled="!editable",:readonly="!editable")
                .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
        b-row
          b-col(cols=6)
            b-form-group(label="代表者名",label-for="input-president",description="",required)
              ValidationProvider(rules="required",name="代表者名",v-slot="{ errors }")
                b-form-input#input-president(v-model="datum.president",type="text",required,placeholder="代表者名を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
          b-col(cols=6)
            b-form-group(label="会社ホームページURL",label-for="input-url",description="")
              ValidationProvider(:rules="{ regex: /^https?:\\/\\/[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)$/ }",name="URL",v-slot="{ errors }")
                b-form-input#input-url(v-model="datum.url",type="url",placeholder="URLを入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
        b-row
          b-col(cols=6)
            b-form-group(label="代表電話番号",label-for="input-tel",description="",required)
              ValidationProvider(:rules="{ required: true, regex: /^0[0-9]{1,4}\-?[0-9]{1,4}\-?[0-9]{4}$/, min: 10, max: 20 }",name="代表電話番号",v-slot="{ errors }")
                b-form-input#input-tel(v-model="datum.tel",type="tel",required,placeholder="電話番号を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
        b-row
          b-col(cols=6)
            b-form-group(label="郵便番号",label-for="input-zip",description="",required)
              ValidationProvider(:rules="{ required: true, regex: /^[0-9]{3}-?[0-9]{4}$/ }",name="郵便番号",v-slot="{ errors }")
                b-form-input#input-zip(v-model="datum.zip",type="text",required,placeholder="郵便番号を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
          b-col(cols=6)
            b-form-group(label="都道府県",label-for="input-prefecture",description="",required)
              ValidationProvider(rules="required",name="都道府県",v-slot="{ errors }")
                b-form-select#input-prefecture(v-model="datum.prefecture",:options="options.prefectures",@change="validateInput",:disabled="!editable",:readonly="!editable")
                .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
        b-row
          b-col
            b-form-group(label="市区町村・番地",label-for="input-locality",description="",required)
              ValidationProvider(rules="required",name="市区町村・番地",v-slot="{ errors }")
                b-form-input#input-locality(v-model="datum.locality",type="text",required,placeholder="市区町村・番地を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
        b-row
          b-col
            b-form-group(label="ビル・マンション名など",label-for="input-building",description="",)
              ValidationProvider(rules="",name="ビル・マンション名",v-slot="{ errors }")
                b-form-input#input-building(v-model="datum.building",type="text",placeholder="ビル・マンション名を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

        b-row
          b-col.locations
            p.small ※求人ポジションごとに勤務地を設定する必要があるため、配属する可能性のある勤務地を設定してください。
              br
              | 配属場所が本社のみの場合でも設定をお願いします。（名称は「本社」など、自由に設定いただいて構いません。）
            label 勤務地
            .form-inline
              b-form-group.mb-2(v-for="(location, index) in datum.locations",:key="index",label="",:label-for="`input-location_${index + 1}-prefecture`",description="",required)
                ValidationProvider.box(rules="required",:name="`都道府県（${index + 1}行目）`",v-slot="{ errors }")
                  b-form-select.input-location-prefectures(:id="`input-location_${index + 1}-prefecture`",v-model="location.prefecture",:options="options.locationPrefectures",@change="validateInput",:disabled="!editable",:readonly="!editable")
                  .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                ValidationProvider.box(rules="required",:name="`名称（${index + 1}行目）`",v-slot="{ errors }")
                  b-form-input.input-location-names.ml-2(:id="`input-location_${index + 1}-name`",v-model="location.name",type="text",placeholder="名称を入力",@input="validateInput",:disabled="!editable",:readonly="!editable")
                  .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

                b-button.removeLocations(variant="link",@click="removeLocations(index)",:disabled="!editable || datum.locations.length <= 1")
                  i.menu-icon.fas.fa-minus-circle

            template(v-if="editable")
              b-button.addLocations(variant="link",@click="addLocations(index)",:disabled="!editable || datum.locations.length >= 100")
                i.menu-icon.fas.fa-plus-circle
                span

    footer.buttons
      template(v-if="currentUser && currentUser.role && (currentUser.role === 'admin' || currentUser.role === 'master')")
        b-button.mr-3(variant="primary",v-show="mode === 'show'",@click="onEdit()",:disabled="!currentUser || !currentUser.role || !(currentUser.role === 'admin' || currentUser.role === 'master')")
          span.ml-1 変更する
        b-button.mr-3(variant="outline-primary",v-show="mode === 'edit'",@click="onCancel()")
          span.ml-1 キャンセル
        b-button.mr-3(variant="primary",v-show="mode === 'edit'",@click="onSave()",:disabled="!valid || !changed")
          span.ml-1 保存する
</template>

<script>
import { isEqual } from 'lodash'

import { getData, patchData } from '../utils/api'

import { clone, difference, optionsSegment, optionsPrefecture } from '../utils/libs'

import 'dayjs/locale/ja'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.locale('ja')
dayjs.extend(localizedFormat)

const page = {
  id: 'company',
  title: '会社情報の編集'
}

export default {
  name: page.id,
  data () {
    return {
      mask: false,
      page: page,
      currentUser: null,
      mode: 'show',
      editable: false,
      changed: false,
      valid: false,
      datum: {},
      recentDatum: {},
      options: {
        segments: [],
        prefectures: [],
        locationPrefectures: []
      }
    }
  },
  watch: {
    $route (to, from) {
      this.changeMode()
    },
    'datum.zip' (val) {
      this.changeZip()
    }
  },
  created () {
    let yubinbangoScript = document.createElement('script')
    yubinbangoScript.setAttribute('src', 'https://yubinbango.github.io/yubinbango-core/yubinbango-core.js')
    document.head.appendChild(yubinbangoScript)
  },
  mounted () {
    this.mode = 'show'

    this.options.segments = optionsSegment()
    this.options.segments.unshift({
      value: null, text: '業界を選択してください' //, disabled: true
    })

    this.options.prefectures = optionsPrefecture()
    this.options.prefectures.unshift({
      value: null, text: '都道府県を選択してください' //, disabled: true
    })

    this.options.locationPrefectures = optionsPrefecture()
    this.options.locationPrefectures.unshift({
      value: null, text: '(未選択)' //, disabled: true
    })

    this.editable = false
    this.changeMode()
  },
  methods: {
    formatDay (val) {
      return val ? dayjs(val).format('YYYY/MM/DD(ddd)') : ''
    },
    changeZip () {
      if (this.mask) { return }
      if (this.datum.zip && this.datum.zip.match(/^[0-9]{3}-?[0-9]{4}$/)) {
        const self = this
        new YubinBango.Core(this.datum.zip, (address) => {
          this.$set(self.datum, 'prefecture', address.region)
          this.$set(self.datum, 'locality', address.locality + address.street)
        })
      }
    },
    async validateInput () {
      this.valid = await this.$refs.observer.validate()

      if (this.datum.locations && this.datum.locations.length > 0) {
        let isEmptyLocation = false
        this.datum.locations.forEach((location) => {
          if (!location.prefecture || !location.name) {
            isEmptyLocation = true
          }
        })
        if (isEmptyLocation && this.datum.locations.length > 1) {
          this.valid = false
        }
      }

      const diffDatum = difference(this.datum, this.recentDatum)
      if (!isEqual({}, diffDatum)) {
        this.changed = true
      }
      this.recentDatum = clone(this.datum)
    },
    changeMode () {
      if (this.mode === 'add' || this.mode === 'edit') {
        this.editable = true
      } else {
        this.editable = false
      }
      this.loadData()
    },
    async loadData () {
      if (!this.$root.currentUser || !this.$root.currentUser.role) {
        setTimeout(() => {
          this.loadData()
        }, 300)
        return
      }
      this.$set(this, 'currentUser', this.$root.currentUser)

      this.mask = true

      let message = ''

      try {
        await getData(`/mycompany`).then((datum) => {
          if (datum) {
            this.datum = clone(datum)

            if (!this.datum.locations || !Array.isArray(this.datum.locations)) {
              this.datum.locations = [{
                prefecture: null,
                name: null
              }]
            }
          }
        }).catch((err) => {
          console.log(err)
          message = 'データの読込に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })

        this.validateInput()

        this.changed = false
        this.valid = false
      } catch (e) {
        message = 'データの読込に失敗しました'
      }

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      }

      this.$parent.$refs.header.checkCondition()

      this.$forceUpdate()
    },
    onEdit () {
      this.loadData()
      this.editable = true
      this.mode = 'edit'
    },
    onCancel () {
      this.loadData()
      this.editable = false
      this.mode = 'show'
    },
    onChange (elm) {
      // debugger
    },
    addLocations () {
      this.datum.locations.push({
        prefecture: null,
        name: null
      })
      this.validateInput()
      this.$forceUpdate()
    },
    removeLocations (index) {
      this.datum.locations.splice(index, 1)
      this.validateInput()
      this.$forceUpdate()
    },
    async onSave () {
      if (this.$root.currentUser.role !== 'admin' && this.$root.currentUser.role !== 'master') {
        return
      }

      this.valid = await this.$refs.observer.validate()
      if (!this.valid) {
        this.msgBoxError('Invalid Inputs')
      } else {
        this.msgBoxConfirm('会社情報を保存しますか？', this.doSave)
      }
    },
    async doSave () {
      this.mask = true

      let datum = clone(this.datum)

      if (datum.foundationDate) {
        datum.foundationDate = dayjs(datum.foundationDate).format('YYYY-MM-DD')
      }

      delete datum.postedAt
      delete datum.PostedBy
      delete datum.patchedAt
      delete datum.PatchedBy

      delete datum._id

      let message = null

      try {
        await patchData(`/mycompany/`, datum).then((json) => {
          this.loadData()
          this.editable = false
          // this.editable = true
          this.mode = 'show'
          // this.mode = 'edit'
        }).catch((err) => {
          console.log(err)
          message = 'データの保存に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })
      } catch (e) {
        console.log(e)
        message = 'データの保存に失敗しました'
      }

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      } else {
        this.$forceUpdate()
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.input-location-names
  min-width 20rem
.locations
  .box
    display inline-block
    vertical-align top
    .form-control-feedback
      display block
      margin-left 1rem
      overflow hidden
.addLocations
.removeLocations
  i
    font-size 1.5rem
.addLocations
  padding 0.5rem 1rem 1.5rem 1rem
.removeLocations
  padding 0.5rem 1rem
  i
    font-size 1.5rem
  &.disabled
    display none
.addLocations i
  color #156eff
.removeLocations i
  color #999
</style>
